import React, { useState } from 'react';
import { FmlxModal, FmlxWizard } from 'fmlx-common-ui';
import ImportSynchTripWizardContext from './importSynchTripWizardContext';
import { SynchTripImportDTO } from 'business/models/Models';
import FileUploadPage from './fileUploadPage';
import MapDataPage from './mapDataPage';
import DataVerficationPage from './dataVerificationPage';
import ImportDataSummaryPage from './importDataSummaryPage';

type ImportSynchTripWizardProps = {
  closeSynchTrip: () => void;
};

enum WizardSteps {
  FILE_UPLOAD = 0,
  MAP_DATA = 1,
  DATA_VERIFICATION = 2,
  IMPORT_DATA_SUMMARY = 3,
}

const ImportSynchTripWizard = ({ closeSynchTrip }: ImportSynchTripWizardProps) => {
  const [nextButtonDisallowed, setNextButtonDisallowed] = useState(true);
  const [fileContent, setFileContent] = useState('');
  const [synchTripImportDTOList, setSynchTripImportDTOList] =
    useState<SynchTripImportDTO[]>();

  const [activeStep, setActiveStep] = useState(WizardSteps.FILE_UPLOAD);
  const [openState, setOpenState] = useState(true);

  const steps = [
    {
      id: WizardSteps.FILE_UPLOAD,
      stepper: {
        title: 'Upload File',
        desc: 'Please Upload File',
        disabled: nextButtonDisallowed,
        error: false,
      },
      content: <FileUploadPage />,
      nextStepCallback: () => {
        setActiveStep((prevState) => prevState + 1);
      },
      backStepCallback: () => {
        setActiveStep((prevState) => prevState - 1);
      },
    },
    {
      id: WizardSteps.MAP_DATA,
      stepper: {
        title: 'Mapping Data',
        desc: 'Please Map Data',
        disabled: nextButtonDisallowed,
        error: false,
      },
      content: <MapDataPage />,
      nextStepCallback: () => {
        setActiveStep((prevState) => prevState + 1);
      },
      backStepCallback: () => {
        setActiveStep((prevState) => prevState - 1);
      },
    },
    {
      id: WizardSteps.DATA_VERIFICATION,
      stepper: {
        title: 'Verification Data',
        desc: 'Please Verify Data',
        disabled: nextButtonDisallowed,
        error: false,
      },
      content: <DataVerficationPage />,
      nextStepCallback: () => {
        setActiveStep((prevState) => prevState + 1);
      },
      backStepCallback: () => {
        setActiveStep((prevState) => prevState - 1);
      },
    },
    {
      id: WizardSteps.IMPORT_DATA_SUMMARY,
      stepper: {
        title: 'Import Data',
        desc: 'Please Import Data',
        disabled: nextButtonDisallowed,
        error: false,
      },
      content: <ImportDataSummaryPage />,
      nextStepCallback: () => {
        setActiveStep((prevState) => prevState + 1);
      },
      backStepCallback: () => {
        setActiveStep((prevState) => prevState - 1);
      },
    },
  ];

  const handleCloseClick = () => {
    closeSynchTrip();
    setOpenState(false);
  };

  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex);
  };

  const handleCancelClick = () => {
    closeSynchTrip();
    setActiveStep(0);
  };

  const handleSkipClick = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevState) => prevState + 1);
    }
  };

  return (
    <ImportSynchTripWizardContext.Provider
      value={{
        fileContent,
        setFileContent,
        setNextButtonDisallowed,
        synchTripImportDTOList,
        setSynchTripImportDTOList,
      }}
    >
      <FmlxWizard
        id="importsynchtripwizard-import"
        title="Import Synchrotron Trip"
        subtitle="This wizard will help you import the synchrotron trip."
        steps={steps}
        activeStep={activeStep}
        open={openState}
        onCloseClick={handleCloseClick}
        onStepClick={handleStepClick}
        onCancelClick={handleCancelClick}
        onSkipClick={handleSkipClick}
        onFinishClick={handleCloseClick}
        disableNextButton={nextButtonDisallowed}
        type={FmlxWizard.Type.MODAL}
        modalSize={FmlxModal.Size.DOUBLE_EXTRA_LARGE}
      />
    </ImportSynchTripWizardContext.Provider>
  );
};

export default ImportSynchTripWizard;
